/**
 * MG Time Tracker Application
 *
 *	InputField.js
 *
 *
 */

import React, { Component } from 'react';
import { matchNode } from '../../../utils/dom';

// SASS Imports
require('./InputField.scss');


class InputField extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen: false};
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevState.isOpen && this.state.isOpen) {
            document.addEventListener('click', this.onClickHandler);
        }

        if(prevState.isOpen && !this.state.isOpen) {
            document.removeEventListener('click', this.onClickHandler);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickHandler);
    }

    onClickHandler(e) {
        let isInside = matchNode(e.target, this.refs.drop);
        if(!isInside || e.target.tagName === 'A') {
            return this.setState({isOpen: false});
        }
        return null;
    }

    render() {
        let className = "";
        let inputTitle = this.props.title;

        if(this.props.hidden) {
            className += ' hidden';
        }
        if(this.props.colClass) {
            className += ` ${this.props.colClass}`;
        }
        if(this.props.hasError) {
            className += ' has-error';
        }

        const isRequired = Boolean(this.props.required);

        if(isRequired) {
            className += ' required';
            inputTitle += ' *';
        }

        const onClick = this.props.onClick
              || (() => this.setState({isOpen: true}));

        const optionsList = this.props.options.map(
            (option, i) => {
                return (
                    <li key={`option-${i}`}>
                        <a
                            onClick={() => this.props.onSelectItem(option.value)}
                        >{option.label}</a>
                    </li>
                );
            },
            this
        );

        const dropDownArow = optionsList.length > 0;
        const isButton = this.props.type === 'button';

        let buttonClasses = ['btn-input'];
        if(this.props.value) {
            buttonClasses.push('btn-has-value');
        }

        if(optionsList.length > 0) {
            buttonClasses.push('btn-has-options');
        }

        let ClearButton = isButton
            && this.props.value
            && <a className='clearBtn' onClick={this.props.onClear}>×</a>;

        return (
            <div
                className={className.trim()}
                style={this.props.disabled ? {opacity: 0.5} : {}}
            >
                <label>{inputTitle}</label>
                <div className={this.props.value
                    ? 'inputWrapper dropDown hasValue'
                    : 'inputWrapper dropDown'
                }>
                    {(isButton)
                        ? <button
                            className={buttonClasses.join(' ')}
                            onBlur={this.props.onBlur}
                            placeholder={this.props.placeholder}
                            value={this.props.value}
                            name={this.props.title}
                            onClick={onClick}
                            disabled={this.props.disabled}
                            required={this.props.required}
                            onChange={this.props.onChange}
                            {...this.props.inputProps}
                        >
                            {this.props.value
                                ? (this.props.onRenderValue
                                    ? this.props.onRenderValue(this.props.value)
                                    : this.props.value)
                                : this.props.placeholder}
                        </button>
                        : <input
                            onBlur={this.props.onBlur}
                            type={this.props.type}
                            value={this.props.value}
                            placeholder={this.props.placeholder}
                            name={this.props.title}
                            onClick={onClick}
                            disabled={this.props.disabled}
                            required={this.props.required}
                            onChange={this.props.onChange}
                            {...this.props.inputProps}
                        />}
                        {ClearButton}
                        {(optionsList.length > 0)
                            && <ul className={this.state.isOpen
                                ? "dropDownList show"
                                : "dropDownList hidden"}
                            >{optionsList}</ul>}
                </div>
            </div>
        );
    }
}

InputField.defaultProps = {
    options: [],
    type: 'text'
};

export default InputField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/InputField.jsx